import { render, staticRenderFns } from "./PaymentPresets.vue?vue&type=template&id=45850bd5&scoped=true"
import script from "./PaymentPresets.vue?vue&type=script&lang=js"
export * from "./PaymentPresets.vue?vue&type=script&lang=js"
import style0 from "./PaymentPresets.vue?vue&type=style&index=0&id=45850bd5&prod&scoped=true&lang=css"
import style1 from "./PaymentPresets.vue?vue&type=style&index=1&id=45850bd5&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45850bd5",
  null
  
)

export default component.exports